<template>
  <main-template>
    <v-row>
      <v-col>
        <v-btn color="primary" class="mb-3" x-small text @click="$router.back()">
          <v-icon left> fa fa-angle-left </v-icon>
        </v-btn>
        <span class="text-h4">
          {{ isAprovador ? "Solicitações de Autorização" : "Meus Pedidos de Autorização" }}
        </span>
      </v-col>
    </v-row>

    <v-row class="mb-2" align="end">
      <v-col v-if="isAprovador" cols="12" sm="6" md="4" class="pt-0 pb-0 mb-4">
        <e-label>Nome do solicitante</e-label>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Pesquisar solicitante..."
          solo
          dense
          single-line
          hide-details
          clearable
        />
      </v-col>

      <v-col cols="12" sm="6" md="3" class="pt-0 pb-0 mb-4">
        <e-label>Data inicial</e-label>
        <v-menu
          v-model="menuDataInicial"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dataInicialFormatada"
              append-icon="fa fa-calendar"
              placeholder="Data inicial"
              readonly
              solo
              dense
              single-line
              hide-details
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="dataInicial = null"
            />
          </template>
          <v-date-picker v-model="dataInicial" :max="dataFinal" @input="menuDataInicial = false" />
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="3" class="pt-0 pb-0 mb-4">
        <e-label>Data final</e-label>
        <v-menu
          v-model="menuDataFinal"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="dataFinalFormatada"
              append-icon="fa fa-calendar"
              placeholder="Data final"
              readonly
              solo
              dense
              single-line
              hide-details
              clearable
              v-bind="attrs"
              v-on="on"
              @click:clear="dataFinal = null"
            />
          </template>
          <v-date-picker v-model="dataFinal" :min="dataInicial" @input="menuDataFinal = false" />
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="2" class="pt-0 pb-0 mb-4 d-flex align-end">
        <v-btn color="grey lighten-3" depressed block @click="limparFiltros">
          <v-icon left small>fa fa-eraser</v-icon>
          Limpar filtros
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pt-0">
        <v-data-table
          :headers="headersComputados"
          :items="autorizacoesFiltradas"
          :loading="carregandoAutorizacoes"
          :items-per-page="10"
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr v-for="(autorizacao, i) of items" :key="i">
                <td>{{ autorizacao.id }}</td>
                <td>{{ autorizacao.pedido ? autorizacao.pedido.descricao : "- - -" }}</td>
                <td>{{ autorizacao.solicitante ? autorizacao.solicitante.name : "- - -" }}</td>
                <td>{{ autorizacao.etapa ? autorizacao.etapa.descricao : "- - -" }}</td>
                <td>
                  {{ autorizacao.created_at ? validarData(autorizacao.created_at) : "- - -" }}
                </td>
                <td>
                  {{
                    autorizacao.data_expiracao
                      ? validarData(autorizacao.data_expiracao)
                      : "Indefinido"
                  }}
                </td>

                <td>
                  <v-chip label x-small :color="mudarCor(autorizacao.status)">
                    {{ autorizacao.status }}
                  </v-chip>
                </td>
                <td v-if="isAprovador">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="abrirDialogAprovador(autorizacao)"
                      >
                        <v-icon small>fa fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Analisar solicitação</span>
                  </v-tooltip>
                </td>
                <td v-if="!isAprovador">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="tentarAbrirDialog(autorizacao)"
                      >
                        <v-icon small>fa fa-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar solicitação</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Modal do aprovador -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="680px">
        <v-card v-if="autorizacaoSelecionada">
          <v-card-title class="primary">
            <span style="color: #fff" class="text-h5">
              Analisar Solicitação #{{ autorizacaoSelecionada.id }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row class="pt-4">
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Solicitante</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.solicitante
                        ? autorizacaoSelecionada.solicitante.name
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Tipo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.pedido
                        ? autorizacaoSelecionada.pedido.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Etapa/Periodo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.etapa
                        ? autorizacaoSelecionada.etapa.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Data da solicitação</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.created_at
                        ? validarData(autorizacaoSelecionada.created_at)
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Motivo da solicitação</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes || "Nenhuma observacao informada." }}
                  </p>
                </v-col>
              </v-row>

              <v-divider class="my-4"></v-divider>

              <ValidationObserver ref="obsAprovador" v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(submitForm)">
                  <v-row>
                    <v-col class="pt-0 pb-0" cols="12" sm="6">
                      <ValidationProvider name="Situacao" rules="required" v-slot="{ errors }">
                        <e-label>Situação <span class="red--text">*</span></e-label>
                        <v-select
                          v-model="novoStatus"
                          :items="situacoesAnalise"
                          :error-messages="errors"
                          dense
                          solo
                        />
                      </ValidationProvider>
                    </v-col>

                    <v-col v-if="novoStatus === 'APROVADO'" class="pt-0 pb-0" cols="12" sm="6">
                      <ValidationProvider
                        name="Data de Expiracao"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <e-label>
                          Data de Expiração
                          <span class="red--text">*</span>
                        </e-label>

                        <v-dialog
                          ref="dialogData"
                          v-model="modalData"
                          :return-value.sync="data_expiracao"
                          persistent
                          width="290px"
                          :retain-focus="false"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="periodo_expiracao"
                              label="Escolha uma data"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense
                              solo
                              :error-messages="errors"
                              clearable
                              @click:clear="limparDataExpiracao"
                            />
                          </template>
                          <v-date-picker
                            v-model="data_expiracao"
                            :min="dataMinimaExpiracao"
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalData = false">Cancelar</v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.dialogData.save(data_expiracao)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </ValidationProvider>
                    </v-col>

                    <v-col class="pt-0 pb-0" cols="12">
                      <ValidationProvider name="Observacao" rules="max:1000" v-slot="{}">
                        <e-label>Observação do Aprovador (opcional)</e-label>
                        <v-textarea
                          v-model="observacoesAprovador"
                          solo
                          dense
                          placeholder="Adicione uma observação ou justificativa..."
                          rows="2"
                          maxlength="1000"
                          :counter="true"
                        >
                          <template v-slot:counter>
                            {{ (observacoesAprovador || "").length }}/1000
                          </template>
                        </v-textarea>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-card-actions class="mt-4">
                    <v-spacer></v-spacer>
                    <v-btn
                      style="color: #fff"
                      class="red darken-1"
                      type="button"
                      :disabled="submittingForm"
                      @click="fecharDialog"
                    >
                      Fechar
                    </v-btn>
                    <v-btn
                      style="color: #fff"
                      class="green darken-1"
                      type="submit"
                      :loading="submittingForm"
                      :disabled="submittingForm || (novoStatus === 'APROVADO' && !data_expiracao)"
                    >
                      Salvar
                    </v-btn>
                  </v-card-actions>
                </form>
              </ValidationObserver>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Modal de detalhes para o solicitante (somente leitura) -->
    <v-row justify="center">
      <v-dialog v-model="dialogSolicitante" max-width="560px">
        <v-card v-if="autorizacaoSelecionada">
          <v-card-title class="primary">
            <span style="color: #fff" class="text-h5">
              Detalhes do Pedido #{{ autorizacaoSelecionada.id }}
            </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <v-row class="pt-4">
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Tipo</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.pedido
                        ? autorizacaoSelecionada.pedido.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Etapa</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.etapa
                        ? autorizacaoSelecionada.etapa.descricao
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Data da solicitação</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.created_at
                        ? validarData(autorizacaoSelecionada.created_at)
                        : "- - -"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Situação</e-label>
                  <p class="font-weight-regular">
                    <v-chip label x-small :color="mudarCor(autorizacaoSelecionada.status)">
                      {{ autorizacaoSelecionada.status }}
                    </v-chip>
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12" sm="6">
                  <e-label class="font-weight-medium">Validade</e-label>
                  <p class="font-weight-regular">
                    {{
                      autorizacaoSelecionada.data_expiracao
                        ? validarData(autorizacaoSelecionada.data_expiracao)
                        : "Indefinido"
                    }}
                  </p>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <e-label class="font-weight-medium">Motivo da solicitação</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes || "- - -" }}
                  </p>
                </v-col>
                <v-col
                  class="pt-0 pb-0"
                  cols="12"
                  v-if="autorizacaoSelecionada.observacoes_aprovador"
                >
                  <e-label class="font-weight-medium">Resposta do aprovador</e-label>
                  <p class="font-weight-regular">
                    {{ autorizacaoSelecionada.observacoes_aprovador }}
                  </p>
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="color: #fff" class="red darken-1" @click="dialogSolicitante = false">
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { dataTableFilter } from "@/plugins/searchQuery";
import ELabel from "../../../components/ELabel.vue";

export default {
  components: { ELabel },

  computed: {
    ...mapGetters("Autorizacoes", ["autorizacoes", "carregandoAutorizacoes", "autorizacoesList"]),

    isAprovador() {
      const role = this.currentUser?.roleName;
      if (role === "super-admin") return true;
      return role === "admin" && !!this.usuarioTiId && this.currentUser.id === this.usuarioTiId;
    },

    headersComputados() {
      const base = [
        { text: "#", value: "id" },
        { text: "Tipo de Solicitação", value: "descricao" },
        { text: "Solicitante", value: "solicitante" },
        { text: "Etapa/Período", value: "etapa" },
        { text: "Data Solicitação", value: "created_at" },
        { text: "Validade", value: "data_expiracao" },
        { text: "Situação", value: "status" },
        { text: "Ações", value: "acoes", sortable: false },
      ];
      return base;
    },
    situacoesAnalise() {
      return this.$constants.situacaoAutorizacao.filter((situacao) => situacao !== "PENDENTE");
    },

    dataMinimaExpiracao() {
      return new Date().toISOString().split("T")[0];
    },

    dataInicialFormatada() {
      return this.dataInicial ? this.validarData(this.dataInicial) : "";
    },

    dataFinalFormatada() {
      return this.dataFinal ? this.validarData(this.dataFinal) : "";
    },

    autorizacoesFiltradas() {
      const nomePesquisado = (this.search || "").trim();

      return this.autorizacoesList.filter((autorizacao) => {
        const nomeCorresponde =
          !nomePesquisado || dataTableFilter(autorizacao.solicitante?.name || "", nomePesquisado);

        const dataSolicitacao = (autorizacao.created_at || "").split("T")[0];
        const dentroDoInicio = !this.dataInicial || dataSolicitacao >= this.dataInicial;
        const dentroDoFim = !this.dataFinal || dataSolicitacao <= this.dataFinal;

        return nomeCorresponde && dentroDoInicio && dentroDoFim;
      });
    },
  },

  data() {
    return {
      data_expiracao: null,
      periodo_expiracao: null,
      novoStatus: null,
      observacoesAprovador: null,
      modalData: false,
      dialog: false,
      dialogSolicitante: false,
      autorizacaoSelecionada: null,
      submittingForm: false,
      search: "",
      dataInicial: null,
      dataFinal: null,
      menuDataInicial: false,
      menuDataFinal: false,
      usuarioTiId: null,
      currentUser: store.getters["Auth/user"],
    };
  },

  async mounted() {
    if (this.currentUser?.roleName === "admin") {
      await this.carregarUsuarioTi();
    }

    if (this.isAprovador) {
      this.$store.dispatch("Autorizacoes/loadAutorizacoes", { tipo: "aprovador" });
    } else {
      this.$store.dispatch("Autorizacoes/loadAutorizacoes", { tipo: "solicitante" });
    }
  },

  watch: {
    carregandoAutorizacoes(value) {
      if (value) {
        this.$loaderService.open("Carregando autorizações...");
      } else {
        this.$loaderService.close();
      }
    },
    data_expiracao(value) {
      if (!value) {
        this.periodo_expiracao = null;
        return;
      }
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(
        new Date(value)
      );
      this.periodo_expiracao = data_old;
    },
    novoStatus(value) {
      if (value !== "APROVADO") {
        this.data_expiracao = null;
      }
      this.$nextTick(() => {
        if (this.$refs.obsAprovador) this.$refs.obsAprovador.validate();
      });
    },
  },

  methods: {
    async carregarUsuarioTi() {
      try {
        const response = await this.$services.autorizacoesService.getUsuarioTi();
        this.usuarioTiId = response.data?.id ?? null;
      } catch (error) {
        this.usuarioTiId = null;
      }
    },

    mudarCor(status) {
      switch (status) {
        case "PENDENTE":
          return "warning";
        case "APROVADO":
          return "green";
        case "RECUSADO":
          return "red";
        default:
          return "grey";
      }
    },

    limparFiltros() {
      this.search = "";
      this.dataInicial = null;
      this.dataFinal = null;
    },

    tentarAbrirDialog(item) {
      this.autorizacaoSelecionada = item;
      if (this.isAprovador) {
        this.abrirDialogAprovador(item);
      } else {
        this.dialogSolicitante = true;
      }
    },

    abrirDialogAprovador(item) {
      this.autorizacaoSelecionada = item;
      this.novoStatus = this.situacoesAnalise.includes(item.status) ? item.status : null;
      this.observacoesAprovador = item.observacoes_aprovador || null;
      this.data_expiracao = item.data_expiracao || null;
      this.dialog = true;
    },

    fecharDialog() {
      this.dialog = false;
      this.autorizacaoSelecionada = null;
      this.novoStatus = null;
      this.data_expiracao = null;
      this.periodo_expiracao = null;
      this.observacoesAprovador = null;
      if (this.$refs.obsAprovador) this.$refs.obsAprovador.reset();
    },

    limparDataExpiracao() {
      this.data_expiracao = null;
      this.periodo_expiracao = null;
    },

    validarData(data) {
      if (!data) return "—";
      const date = new Date(data);
      if (isNaN(date.getTime())) return data;
      return new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
    },

    async submitForm() {
      const valid = await this.$refs.obsAprovador.validate();
      if (!valid) return;

      this.submittingForm = true;
      try {
        await this.$services.autorizacoesService.atualizarAutorizacao({
          id: this.autorizacaoSelecionada.id,
          status: this.novoStatus,
          data_expiracao: this.data_expiracao,
          observacoes_aprovador: this.observacoesAprovador,
          user_aprovador: this.currentUser.id,
        });
        this.$toast.success("Pedido atualizado com sucesso!");
        this.fecharDialog();
        this.$store.dispatch("Autorizacoes/loadAutorizacoes");
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
  },
};
</script>

<style></style>
